/**
 * lp-expert-quote — one slide at a time, arrows on desktop and dots on phones.
 *
 * The track is a flex row of full-width slides moved with a transform, so the
 * viewport never scrolls and there is nothing to measure: slide N sits at
 * -N * 100%. Both controls drive the same index.
 */
(function () {
  function init(root) {
    if (root.dataset.lpExpertQuoteReady) return;
    root.dataset.lpExpertQuoteReady = 'true';

    var track = root.querySelector('[data-lp-expert-quote-track]');
    if (!track) return;

    var slides = track.children;
    var count = slides.length;
    if (count < 2) return;

    var prev = root.querySelector('[data-lp-expert-quote-prev]');
    var next = root.querySelector('[data-lp-expert-quote-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-lp-expert-quote-dot]'));
    var index = 0;

    function render() {
      track.style.transform = 'translateX(' + index * -100 + '%)';
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === count - 1;
      // Slides off-screen stay in the layout, so hide them from tab order.
      Array.prototype.forEach.call(slides, function (slide, i) {
        slide.inert = i !== index;
      });
    }

    function go(to) {
      index = Math.max(0, Math.min(count - 1, to));
      render();
    }

    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { go(i); });
    });

    render();
  }

  function initAll() {
    document.querySelectorAll('[data-lp-expert-quote]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-run when the theme editor re-renders the section.
  document.addEventListener('shopify:section:load', initAll);
})();
